/* global jQuery, ga_event, jarallax, glider, quoteSlider */
jQuery(document).ready(function($) {

	/****************************************************************
		Loading Youtube videos onclick. Saves 300kb on page load
	****************************************************************/
	$(document).on("click", ".event-enable-video", function(e) {
		var t = $(this);
		var w = t.attr("data-width");
		var h = t.attr("data-height");
		var url = t.attr("href");
		var target = t.attr("data-target");		
		
		t.closest(".enable-video-container").hide();
		$(target).html('<iframe width="'+w+'" height="'+h+'" src="'+url+'" frameborder="0" allowfullscreen></iframe>');
		$(".content").fitVids();
		
		ga_event({
			"category": "video",
			"action": "played",
			"label": url,
			"value": 1
		});	
		
		return false;
	});
	
	
	/****************************************************************
		Generic input value clearing
	****************************************************************/
	$(document).on("click", "[data-clear-input-target]", function(e){
		var t = $(this);
		$(t.attr("data-clear-input-target")).val("");
		return false;
	});
	
	
	/****************************************************************
		Generic copy DOM Nodes
	****************************************************************/
	$("[data-copy-node-source]").each(function(index, element) {
		var t = $(this);
		var source = t.attr("data-copy-node-source");
		var cloned = $(source).clone();
		t.html(cloned);
	});
	
	
	/****************************************************************
		Generic scroll to - //http://djpate.com/2009/10/07/animated-scroll-to-anchorid-function-with-jquery/
	****************************************************************/
	$(document).on("click", "[data-scroll-to]", function(e) {
		var t = $(this);
		var target = t.attr("data-scroll-to");
		$("html,body").animate({scrollTop: $(target).offset().top - $(".header").height()},300); //If a fixed header is present, don't forget to add that height here.
		return false;
	});

	
	/****************************************************************
		Toggle Panel
	****************************************************************/
	$(document).on("click", ".toggle-panel-nav a", function(e) {
		
		var t = $(this);
		var target = t.attr("href");	
		var root = t.parent().parent();

		$(root).find(".toggle-panel > li").removeClass("active");	
		$(target).addClass("active");
		
		$(t).parent().find("a").removeClass("active");	
		t.addClass("active");
				
		jarallax(document.querySelectorAll(".no-touch .jarallax"), "onResize"); //Jaralax bug
			
		return false;
	});
	
	
	/****************************************************************
		Reveal Card for touch
	****************************************************************/
	$(document).on("click", ".touch .reveal-card-anchor", function(e) {		
		var t = $(this);
		
		t.closest(".reveal-card").addClass("active");
		t.closest(".reveal-card").find(".reveal-card-anchor").hide();

		return false;
	});
		
	
	/****************************************************************
		Toggle AOS animations on smaller screens
	****************************************************************/
	$(".mobilenav [data-aos-children-mobile-change]").each(function(index, element) {
		var t = $(this);
		var animation = t.attr("data-aos-children-mobile-change");
		t.find("[data-aos]").attr("data-aos",animation).attr("data-aos-delay","0");
	});

	if($('.glide__arrows').length > 0) {

		$('.glide__arrow--left').attr('data-disabled', 'true');

		var left = 	$('.glide__arrow--left');
		var right = $('.glide__arrow--right');

		if($('.segment-slider').length > 0) {
			glider.on('run', function(){
				if (left) {
					if (glider.index === 0) {
						left.attr('data-disabled', 'true');
					} else {
						left.attr('data-disabled', 'false');
					}
				}

				if (right) {
					var track_length = $('.segment-slider ul li.glide__slide').length;
					if (glider.index === (track_length - 1)) {
						right.attr('data-disabled', 'true');
					} else {
						right.attr('data-disabled', 'false');
					}
				}
			});
		}

		if($('.quote-slider').length > 0) {
			quoteSlider.on('run', function(){
				if (left) {
					if (quoteSlider.index === 0) {
						left.attr('data-disabled', 'true');
					} else {
						left.attr('data-disabled', 'false');
					}
				}

				if (right) {
					var track_length = $('.quote-slider ul li.glide__slide').length;
					if (quoteSlider.index === (track_length - 1)) {
						right.attr('data-disabled', 'true');
					} else {
						right.attr('data-disabled', 'false');
					}
				}
			});
		}

	}

	$('.post-password-required form').on('submit', function(e) {
		if($(this).find('input').val() === "") {
			e.preventDefault();
			var results = "<p>Please enter a password to continue.</p>";
			$(results).insertAfter($(this).find('input'));
		}
	});

});

/****************************************************************
	US Venture Open Redirect
****************************************************************/
if (window.location.href== "http://www.usventure.com/usVentureOpen/Pages/default.aspx") {
	window.location.href = 'http://www.usventureopen.com/'; 
}


/****************************************
 * 
 *   Market Segments page scroll-to-anchor
 * 
************************************** */
jQuery(document).ready(function(){

	function scrollToSection(market_id) {
			let position = jQuery(`.market[market-id="${market_id}"]`).length > 0 ? jQuery(`.market[market-id="${market_id}"]`).offset().top : 0;
			if(jQuery('header.header').is(':visible')) {
					position = position - jQuery('header.header').height();
			} else {
					position = position - jQuery('header.header-mobile .bg--white').height();
			}
			jQuery('html').animate({scrollTop: position}, 1000);
	}

	if (jQuery('.section-markets').length > 0) {
		jQuery('select[name="select-market"]').change(function(){
				let market_id = jQuery(this).val();
				scrollToSection(market_id);
		});
		
		const market_id = window.location.hash.substring(1);
		if ( market_id > '') {
				scrollToSection(market_id);
		}
	}
});
